import {z} from '@hono/zod-openapi';

import {ISSUE_REPORT_ATTACHMENT_LIMITS as LIMITS} from './ISSUE_REPORT_ATTACHMENT_LIMITS';
import {singleLineText} from './IssueReportDiagnosticsSchema';

/**
 * A reference to a file the reporter already uploaded; the API fetches the bytes server-side. The
 * storage service mints the id as a UUID, so pin it to that shape — the id is spliced into the
 * storage URL, and free text there is a path the reporter controls. The filename is
 * reporter-controlled and becomes the attachment name, hence single-line.
 */
export const issueReportAttachmentSchema = z
  .object({
    fileId: z.string().uuid().openapi({example: 'fd52216c-1556-40b7-aa7f-cde9b9814812'}),
    filename: singleLineText(LIMITS.filename),
  })
  .openapi('IssueReportAttachment');

export type IssueReportAttachment = z.infer<typeof issueReportAttachmentSchema>;
